<template>
<a class="com-topic-title" @click.stop.prevent="routeTopic">{{title}}</a>
</template>

<script>
import VueTypes from 'vue-types'

/**
 * 频道标签
 * @module component/TopicTitle
 * @example <TopicTitle :style="tagSpace" :id="tag.alias || tag.id" :title="tag.name" />
 */
export default {
  name: 'topic-title',
  /**
   * 传入数据
   * @property {String|Number}  id     频道的别名或者 ID
   * @property {String}         title  频道标题
   */
  props: {
    id: VueTypes.oneOfType([String, Number]).isRequired,
    title: VueTypes.string.isRequired
  },
  methods: {
    /**
     * 跳转到频道详情页
     * @desc 跳转前做一次 ga 上报，跳转链接为 `/topic/${this.id}`
     * @func
     */
    routeTopic () {
      window.ga && window.ga('send', {
        hitType: 'event',
        eventCategory: 'topic_click',
        eventAction: this.title
      })

      window.open(`/topic/${this.id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/common";

.com-topic-title {
  @extend %animateFontHover;
  cursor: pointer;
}
</style>

